/* eslint-disable @typescript-eslint/no-explicit-any, camelcase */

/**
 * This file is autogenerated, please don't edit it manually.
 * Use this command to regenerate it if you modified Epic experiments:
 * yarn epic:types
 */

/**
 * Epic experiments namespaces with their possible keys.
 * Autogenerated from static/bundles/epic/data/defaults/
 */
import client from 'bundles/epic/client';
import Enterprise from 'bundles/epic/data/defaults/Enterprise.json';
import type { Tags } from 'bundles/epic/lib/EpicTypes';

type Namespace = {
  enableOrgForProgramAdminLeaderboard: any;
  whitelistOrganizationProgramsForSSOLogin: any;
  unifyProgramCreationForWes: boolean;
  disableSentMessagesForOrg: any;
  enableSalesforceSandbox: boolean;
  fullStoryContentCurationEnabled: boolean;
  enableUserDataDelayBanner: boolean;
  enableTeamsLandingContentfulIntegration: boolean;
  enterpriseSearchShadow: boolean;
  enableMicroBadgeReporting: boolean;
  enableInternalCourseraWarningBanner: any;
  enableClipsInCollections: boolean;
  fullscreenProductModal: boolean;
  openSearchInNewPage: boolean;
  enableCourseBuilder: boolean;
  enableLearnerPage: boolean;
  enableAiProgramBuilder: boolean;
  enableProgramBuilderForOrg: any;
  renameUtilizationDashboards: boolean;
  wesPasswordLessRegistration: 'control' | 'existingFlowPostConfirmation' | 'passwordCreationPostConfirmation';
  enableWESSandboxCheckout: boolean;
  enableRecruiterDashboardUpdates: any;
  enableRecruiterInvitationFlow: any;
  enableSeparateReports: any;
  enableAssignLearningPaths: boolean;
  enableCourseProfiles: boolean;
  enableAdminSyncFlow: boolean;
  migrateEnterpriseContractProvisionActions: boolean;
  enableBillableVsNonBillableConsistency: boolean;
  enterpriseUsageReportSyncFlow: boolean;
  enableLearningPathLibrary: boolean;
  enableNewLearnersPageControl: boolean;
  enableNewLearnersPageTreatment: boolean;
};

const NAMESPACE = 'Enterprise';

// Adding safe optional chaining to avoid massive changes in unit tests.
client.addDefaults?.([Enterprise as $TSFixMe]);

const EnterpriseEpicClient = {
  get<K extends keyof Namespace>(key: K, tags?: Tags): Namespace[K] {
    return client.get(NAMESPACE, key, tags);
  },

  preview<K extends keyof Namespace>(key: K, tags?: Tags, defaults?: Namespace): Namespace[K] {
    return client.preview(NAMESPACE, key, tags);
  },
};

export default EnterpriseEpicClient;
